import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetLastOperationDateProps = {
  societyId: string;
};

export const getLastOperation =
  ({ societyId }: GetLastOperationDateProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { societyId } };

    try {
      const { data } = await axiosV2.get('/operations/last', query);
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
